<template lang="pug">
.consultation-list
  n-delete-dialog(
    :value="!!deletingItem"
    :seconds="0"
    @ok="handleDeleteConsultation"
    @close="deletingItem = null"
  )
    span.primary--text Wollen Sie die Beratung "{{ deletingItem ? deletingItem.name: '' }}"" wirklich löschen?

  h2.primary--text Liste Beratungen

  v-row.align-center.mt-4
    v-col(cols="6")
      v-text-field.pt-0(
        v-model="search"
        append-icon="search"
        placeholder="Suchen"
        outlined
        single-line
        hide-details
      )

    v-col.text-right(v-if="selectedCompany" cols="6")
      v-btn(color="primary" @click="gotoRoute('rimas-light-add')") + Neue Light Beratung

  v-data-table.mt-4(
    v-bind="tableProps"
    :headers="headers"
    :items="consultations"
    :search="search"
    :options="defaultPagination"
  )
    template(#item="{ item }")
      tr(:class="item.step === 'hidden' && 'hidden-row'")
        td {{ item.id }}
        td {{ item.name }}
        td {{ item.description }}
        td.text-center {{ formatDateTime(item.date_created, 'DD.MM.YYYY') }}
        td.text-center {{ item.rule_description }}

        td: .d-flex.align-center.justify-end
          a.d-flex.mr-1(title="Beratung bearbeiten" @click.prevent="onEditConsultation(item.id)")
            i.fo.fo-large.fo-pencil

          a.d-flex.mr-1(
            title="Beratung löschen"
            @click.prevent="deletingItem = item"
          )
            i.fo.fo-large.fo-trash-bin

    template(#footer.page-text="{ pageStart, pageStop }")
      span Von {{ pageStart }} bis {{ pageStop }}
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { mapActions } from 'vuex'

import FormMixin from '@/mixins/form'
import Urls from '@/router/urls'

@Component({
  mixins: [
    FormMixin
  ],

  methods: mapActions([
    'selectCompany'
  ])
})
export default class ConsultationLightList extends Vue {
  search = ''
  consultations = []
  headers = [
    {
      text: 'ID',
      align: 'left',
      sortable: true,
      value: 'id'
    },
    {
      text: 'Name',
      align: 'left',
      sortable: true,
      value: 'name'
    },
    {
      text: 'Beschreibung',
      align: 'left',
      sortable: true,
      value: 'description'
    },
    {
      text: 'Erstellt am',
      align: 'center',
      sortable: true,
      value: 'date_created'
    },
    {
      text: 'Regelwerk',
      align: 'center',
      sortable: true,
      value: 'rule_description'
    },
    {
      text: 'Aktion',
      align: 'right',
      sortable: false,
      value: '#'
    },
  ]

  loading = false
  deletingItem = null

  created () {
    this.loadLightConsultations()
  }

  loadLightConsultations () {
    this.$axios
      .get(Urls.ConsultationLightList(), { templates: false })
      .then(res => {
        this.consultations = res.data || []
      })
  }

  onEditConsultation (itemId) {
    this.$router.push({
      name: 'rimas-light-edit',
      params: {
        id: itemId
      }
    })
  }

  handleDeleteConsultation () {
    this.loading = true

    this.$axios
      .post(Urls.ConsultationLightDelete(), {
        id: this.deletingItem.id,
      })
      .then(() => {
        this.loadLightConsultations()
        this.deletingItem = null
      })
      .catch(err => {
        this.$toast.error(err.message, 'Fehler')
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>

<style lang="sass">
tr.hidden-row
  background-color: #F5A9A9
</style>
